(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['module', 'exports', 'babel-runtime/helpers/classCallCheck', 'babel-runtime/helpers/createClass', 'promise', './util/request'], factory);
  } else if (typeof exports !== "undefined") {
    factory(module, exports, require('babel-runtime/helpers/classCallCheck'), require('babel-runtime/helpers/createClass'), require('promise'), require('./util/request'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports, global.classCallCheck, global.createClass, global.promise, global.request);
    global.base = mod.exports;
  }
})(this, function (module, exports, _classCallCheck2, _createClass2, Promise, jsonp) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

  var _createClass3 = _interopRequireDefault(_createClass2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Base = function () {
    function Base() {
      (0, _classCallCheck3.default)(this, Base);
    }

    (0, _createClass3.default)(Base, null, [{
      key: 'getRegisterUrl',
      value: function getRegisterUrl(callback) {
        return 'https://account.aliyun.com/register/register.htm?oauth_callback=' + encodeURIComponent(callback);
      }
    }, {
      key: 'getLoginUrl',
      value: function getLoginUrl(callback) {
        return 'https://account.aliyun.com/login/login.htm?oauth_callback=' + encodeURIComponent(callback);
      }
    }, {
      key: 'getRealUrl',
      value: function getRealUrl() {
        return 'https://account.console.aliyun.com/#/auth/home';
      }
    }, {
      key: 'isLogin',
      value: function isLogin() {
        return new Promise(function (resolve, reject) {
          jsonp({
            url: '//promotion.aliyun.com/user/accountInfo.htm',
            callback: 'cback',
            success: function success(res) {
              if (res.code == '200') {
                resolve(true);
              } else {
                resolve(false);
              }
            },
            error: function error(err) {
              reject(err);
            }
          });
        });
      }
    }]);
    return Base;
  }();

  exports.default = Base;
  module.exports = exports['default'];
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aliyun-business@1.0.30@@ali/aliyun-business/lib/base.js
// module id = 97
// module chunks = 0 1 2